import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginScreen } from './components/auth/LoginScreen';
import { Shell } from './components/shell/Shell';
import { AuthProvider, useAuth } from './lib/auth';
import { Analytics } from './pages/Analytics';
import { Campanhas } from './pages/Campanhas';
import { Clientes } from './pages/Clientes';
import { Config } from './pages/Config';
import { Dinheiro } from './pages/Dinheiro';
import { Inicio } from './pages/Inicio';
import { Links } from './pages/Links';
import { Loja } from './pages/loja/Loja';
import { Produtos } from './pages/Produtos';
import { ProdutoEntrega } from './pages/produtos/ProdutoEntrega';
import { Vendas } from './pages/Vendas';

function Gate() {
  const { status } = useAuth();

  if (status !== 'logged_in') return <LoginScreen />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Inicio />} />
        <Route path="vendas" element={<Vendas />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="produtos" element={<Produtos />} />
        <Route path="produtos/:id" element={<ProdutoEntrega />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="links" element={<Links />} />
        <Route path="dinheiro" element={<Dinheiro />} />
        <Route path="campanhas" element={<Campanhas />} />
        <Route path="loja" element={<Loja />} />
        <Route path="config" element={<Config />} />
        {/* rotas antigas → telas que as absorveram */}
        <Route path="assinantes" element={<Navigate to="/clientes" replace />} />
        <Route path="ajustes" element={<Navigate to="/config" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}
